import { formatDate, Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { NoteStateEnums } from 'src/app/enum/note-state-enums';
import { NoteTypeEnums } from 'src/app/enum/note-type-enums';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { NoteModel } from 'src/app/models/invoicing/note.model';
import { RequestNotePrintModel } from 'src/app/models/invoicing/request-note-print.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { NoteService } from 'src/app/services/invoicing/note.service';
import { RequestNoteService } from 'src/app/services/invoicing/request-note.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-request-note',
  templateUrl: './register-request-note.component.html',
  styleUrls: ['./register-request-note.component.scss'],
  standalone: false
})
export class RegisterRequestNoteComponent implements OnInit {

  @ViewChild('attachFileRequestNote') attachFileRequestNoteComponent?: CustomModalComponent | null = null;

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly bussinessDocumentsTypeService = inject(BussinessDocumentsTypeService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly enterpriseService = inject(EnterpriseService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formatService = inject(FormatService);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly headerService = inject(HeaderService);
  private readonly invoiceService = inject(InvoiceService);
  private readonly location = inject(Location);
  private readonly noteService = inject(NoteService);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly requestNoteService = inject(RequestNoteService);
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  branchId: number = 0;
  bussinessDocumentsClassId: number = BussinessDocumentsClassEnums.notaCredito;
  bussinessDocumentsTypeClass: number = BussinessDocumentsClassEnums.factura;
  bussinessDocumentsTypeInvoiceForm: FormControl = new FormControl(0);
  bussinessDocumentsTypeInvoiceId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  clientId: number = 0;
  codeCurrency: string = '';
  codeNameClient: string = '';
  codeNameCostCenter: string = '';
  companyId: number = 0;
  costCenterId: number | null = null;
  dateInvoice: string = '';
  disabledActions: boolean = false;
  disabledButtons: boolean = false;
  enterpriseId: number = 0
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formRequestNote: FormGroup = new FormGroup({});
  formRequestNoteTotals: FormGroup = new FormGroup({});
  headerChanged: boolean = false;
  buttonAnnuls: boolean = false;
  iconStateProcess: string = '';
  iconStateRequestNote: string = '';
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  invoiceConsecutive: number = 0;
  invoiceId: number = 0;
  invoiceSwIcaSelfRetainer: boolean = false;
  invoiceSwSelfRetainer: boolean = false;
  isLevelArticle: boolean = false;
  isOpened: string | undefined = undefined;
  listBranches: CustomListDropdown[] = [];
  listBussinessDocumentsTypes: CustomListDropdown[] = [];
  listBussinessDocumentsTypesInvoice: CustomListDropdown[] = [];
  listConcepts: CustomListDropdown[] = [];
  listEnterprises: any[] = [];
  listNoteTypes: CustomListDropdown[] = [];
  listNoteTypeFiltered: CustomListDropdown[] = [];
  listLevel: CustomListDropdown[] = [
    { label: 'Artículo', value: true },
    { label: 'Concepto', value: false }];
  listOperationsTypeDian: CustomListDropdown[] = [
    { label: '20 - Referencia factura electrónica', value: 20 },
    { label: '22 - Sin referencia a facturas', value: 22 },
    { label: '0 - Referencia factura (No Electrónica)', value: 0 }];
  copyListOperationsTypeDian: CustomListDropdown[] = [];
  listFiles: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Solicitud de Notas';
  noteContract: NoteModel = new NoteModel();
  noteId: number = 0;
  noteTypeId: number = 0;
  outputForAttachFiles$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  permissionPrint: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  printNoteFormat: boolean = false;
  quantityDetails: number = 0;
  requestNotePrintModel: RequestNotePrintModel = new RequestNotePrintModel();
  requestNoteStateString: string = '';
  residueValueInvoice: number = 0;
  severityState: string = "danger";
  stateClientId: ClientStateEnums.activo;
  stateCostCenterId: number = 0;
  subscription: Subscription;
  swElectronicInvoice: boolean = false;
  titleStateProcess: string = '';
  titleStateRequestNote: string = '';
  totalValueInvoice: number = 0;
  typeConcept: number = TypeConceptEnums.notaCredito;
  url: string = 'request-note';
  userAuthenticated: UserModel = new UserModel();
  componentAttachFiles = CustomAttachFilesComponent;

  async ngOnInit() {
    this.validateForm(this.noteContract);
    this.getPermissionPrint();
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.noteId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} -  ${this.projectName}`);
    this.handleInitialState();

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    await this.getFormatByCompanyAndCode();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async annulInvoiceByNote() {
    if (!this.noteContract || !this.noteContract.noteId || this.noteContract.noteId === 0) {
      this.toastHandlerService.showToast('warning', 'Primero debe guardar la solicitud de nota antes de poder anular la factura.', 'Atención');
      return;
    }
    const accepted = await this.confirmDialogService.confirm(
      `¿Realmente desea ANULAR esta factura? Luego de anulada la factura no podrá ser modificada.`
    );
    if (accepted) {
      try {
        this.noteContract = await firstValueFrom(this.requestNoteService.annulInvoiceByRequestNote(this.noteId));
        this.noteId = this.noteContract.noteId;
        this.validateForm(this.noteContract);
      } catch (error) {
        console.error('Error anulando la factura:', error);
      }
    }
  }

  async annulRequestNote() {
    if (!this.noteContract || !this.noteContract.noteId || this.noteContract.noteId === 0) {
      this.toastHandlerService.showToast('warning', 'Primero debe guardar la solicitud de nota antes de poder anularla.', 'Atención');
      return;
    }
    const accepted = await this.confirmDialogService.confirm(
      `¿Realmente desea ANULAR esta solicitud de nota? Luego de anulada la solicitud no podrá ser modificada.`
    );
    if (accepted) {
      try {
        this.noteContract = await firstValueFrom(this.requestNoteService.annulRequestNote(this.noteId));
        this.validateForm(this.noteContract);
      } catch (error) {
        console.error('Error anulando la solicitud de nota:', error);
      }
    }
  }

  async applyNoteTypeConfig(noteTypeId: number): Promise<void> {
    const typeConfig = {
      [NoteTypeEnums.creditNote]: {
        classId: BussinessDocumentsClassEnums.notaCredito,
        concept: TypeConceptEnums.notaCredito,
        buttonAnnuls: false
      },
      [NoteTypeEnums.debitNote]: {
        classId: BussinessDocumentsClassEnums.notaDebito,
        concept: TypeConceptEnums.notaDebito,
        buttonAnnuls: true
      }
    };

    const config = typeConfig[noteTypeId as keyof typeof typeConfig] || {
      classId: BussinessDocumentsClassEnums.documSoporte,
      concept: TypeConceptEnums.notaCredito
    };

    this.noteTypeId = noteTypeId;
    this.typeConcept = config.concept;
    this.bussinessDocumentsClassId = config.classId;
    this.buttonAnnuls = config.buttonAnnuls;

    await this.updateConceptListByNoteType();
  }

  changeEnterprise() {
    const branchId = this.formRequestNote.get("branchId")?.value;
    const noteTypeId = this.formRequestNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formRequestNote.get("bussinessDocumentsTypeId")?.value;
    this.branchId = branchId;
    this.noteTypeId = noteTypeId;
    this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    this.resetNoteState();
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.noteContract.enterpriseId = this.enterpriseId;
    this.noteContract.noteTypeId = noteTypeId;
    this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
    this.validateForm(this.noteContract);
    this.location.replaceState(`/request-note/register`);
  }

  async changeBussinessDocumentsType() {
    const branchId = this.formRequestNote.get("branchId")?.value;
    const enterpriseId = this.formRequestNote.get("enterpriseId")?.value;
    const noteTypeId = this.formRequestNote.get("noteTypeId")?.value;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.noteTypeId = noteTypeId;
    this.resetNoteState();
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.noteContract.enterpriseId = enterpriseId;
    this.noteContract.noteTypeId = noteTypeId;
    this.noteContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
    this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
    this.validateForm(this.noteContract);
    this.location.replaceState(`/request-note/register`);
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.noteId = 0;
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.validateForm(this.noteContract);
    try {
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } catch (error) {
      console.error('Error al buscar las empresas de la sucursal.', error);
    }
    this.location.replaceState(`/request-note/register`);
  }

  async changeNoteType(noteTypeId: number): Promise<void> {
    await this.applyNoteTypeConfig(noteTypeId);
    await this.getFirstBussinessDocumentsType();
    this.changeBussinessDocumentsType();
    this.location.replaceState(`/request-note/register`);
  }

  async changeRequestConsecutive() {
    let requestConsecutive = this.formRequestNote.get("requestConsecutive")?.value;
    if (this.noteContract.requestConsecutive == requestConsecutive) return;
    const branchId = this.formRequestNote.get("branchId")?.value;
    const enterpriseId = this.formRequestNote.get("enterpriseId")?.value;
    const noteTypeId = this.formRequestNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formRequestNote.get("bussinessDocumentsTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (noteTypeId == null || noteTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de nota.', 'Atención');
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (requestConsecutive == 0) {
      requestConsecutive = null;
    }

    if (requestConsecutive == null) {
      this.noteId = 0;
      const modelNote = new NoteModel();
      modelNote.branchId = branchId;
      modelNote.enterpriseId = enterpriseId;
      modelNote.noteTypeId = noteTypeId;
      modelNote.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      this.noteContract = modelNote;
    } else {
      try {
        this.noteContract = await firstValueFrom(this.requestNoteService.getRequestNoteByKeysAsync(
          branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId, requestConsecutive
        ));
        this.noteId = this.noteContract.noteId;
        this.validateForm(this.noteContract);
        this.location.replaceState(`/request-note/register/${this.noteId}`);
      } catch (error) {
        console.error('Error al buscar la nota por llaves:', error);
      }
    }
  }

  async changeStateNote(open: boolean) {
    if (this.noteContract.requestConsecutive == 0) {
      this.toastHandlerService.showToast('warning', 'La solicitud de nota no está guardada.', 'Atención');
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.noteContract = await firstValueFrom(this.requestNoteService.setRequestNoteStateAsync(this.noteContract.noteId, open));
        this.validateForm(this.noteContract);
        this.toastHandlerService.showToast('success', 'El estado de la solicitud de nota se modificó exitosamente.');
      } catch (error) {
        console.error('Error al modificar el estado de la solicitud de nota:', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de solicitudes de notas. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async changeInvoice(consecutiveDocument: number) {
    const consecutive = consecutiveDocument;
    if (consecutive == null || consecutive == 0 || consecutive == -1) {
      this.getCostCenter(new CostCenterModel());
      this.getClient(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      return;
    }
    this.invoiceConsecutive = consecutive;
    this.getInvoiceByCode();
  }

  changeLevel(level: any) {
    const currentLevel = this.noteContract.isLevelArticle;
    if (currentLevel !== level) {
      this.noteContract.isLevelArticle = level;
    }
  }

  changeValues() {
    if (this.noteContract.noteId != 0) {
      this.headerChanged = true
    };
    const operationTypeDian = this.formRequestNote.get("operationTypeDian")?.value;
    if (operationTypeDian == 22) {
      this.toastHandlerService.showToast('info', 'Tenga presente que al sincronizar electronicamente una nota sin referencia a facturas. NO se enviara a la DIAN la informacion de factura afectada.', 'Atención');
    }
  }

  clearClientData() {
    this.stateClientId = ClientStateEnums.activo;
    this.clientId = 0;
    this.codeCurrency = '';
    this.codeNameClient = '';
  }

  async createNewRequestNote() {
    if (this.permissionUpdatable) {
      this.resetNoteState();
      this.requestNotePrintModel = new RequestNotePrintModel();
      this.noteContract = new NoteModel();
      this.noteContract.branchId = this.branchId;
      this.noteContract.enterpriseId = this.enterpriseId;
      this.noteContract.noteTypeId = this.noteTypeId;
      this.noteContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
      this.noteContract.requestConsecutive = 0;
      this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
      await this.validateForm(this.noteContract);
      this.location.replaceState(`/request-note/register`);
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear solicitudes de notas. Comuníquese con el administrador del sistema.', 'Atención');
    }
  }

  private configureNoteType(): void {
    this.applyNoteTypeConfig(this.noteContract.noteTypeId)
    this.formRequestNote.controls["noteTypeId"].patchValue(this.noteContract.noteTypeId);
  }

  async deleteFile(file: any) {
    if (this.noteContract.noteId != 0) {
      const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar el adjunto seleccionado?`);
      if (accepted) {
        try {
          await firstValueFrom(this.requestNoteService.deleteFilesToRequestNote(this.noteId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToRequestNote();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  async deleteRequestNote() {
    if (this.noteContract.noteId != 0) {
      if (this.permissionUpdatable) {
        const accepted = await this.confirmDialogService.confirm(
          `¿Realmente desea eliminar la solicitud de nota ${this.noteContract.requestConsecutive}?`
        );
        if (accepted) {
          try {
            await firstValueFrom(this.requestNoteService.deleteRequestNote(this.noteContract.noteId));
            this.toastHandlerService.showToast('success', 'La solicitud de nota fue eliminada exitosamente.');
            this.createNewRequestNote();
          } catch (error) {
            console.error('Error al eliminar la solicitud de nota:', error);
          }
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para eliminar solicitudes de notas. Comuníquese con el administrador del sistema.',
          'Atención'
        );
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la solicitud de nota.', 'Atención');
    }
  }

  downloadFile(fileName: any) {
    if (this.noteContract.noteId != 0) {
      this.requestNoteService.downloadFileToRequestNote(this.noteId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editNote() {
    this.requestNotePrintModel = new RequestNotePrintModel();
    await this.getNoteById();
    this.configureNoteType();
    this.noteId = this.noteContract.noteId;
    this.enterpriseId = this.noteContract.enterpriseId;
    this.bussinessDocumentsTypeId = this.noteContract.bussinessDocumentsTypeId;
    this.validateForm(this.noteContract);
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists() {
    try {
      const [branches, enterprises, noteType, concept] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)),
        firstValueFrom(this.noteService.getAllNoteTypeForSelectsAsync()),
        firstValueFrom(this.noteService.getAllConceptForSelectAsync(this.typeConcept)),
      ]);
      this.listBranches = branches;
      this.listEnterprises = enterprises;
      this.listNoteTypes = noteType;
      this.listConcepts = concept;
      this.initNoteTypeOptions();
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean): Promise<void> {
    this.branchId = branchId ?? 0;
    this.formRequestNote.controls["branchId"].patchValue(this.branchId);

    if (reload) {
      await this.changeBranch(this.branchId);
      await this.getFirstEnterpriseByBranch(branchId);
    }
  }

  async getClient(clientId: number | null) {
    if (!clientId) {
      this.clearClientData();
      return;
    }
    try {
      const client = await firstValueFrom(this.noteService.getClientByIdForRegisterNoteAsync(clientId));
      if (client) {
        this.codeNameClient = client.label;
        this.clientId = clientId;
        this.stateClientId = client.clientStateId;
        this.codeCurrency = client.codeCurrency;
      } else {
        this.clearClientData();
      }
    } catch (error) {
      console.error('Error al obtener el cliente:', error);
      this.clearClientData();
    }
  }

  async getCostCenter(costCenterModel: CostCenterModel | null) {
    if (costCenterModel != null && costCenterModel.costCenterId != 0) {
      this.codeNameCostCenter = `${costCenterModel.code} - ${costCenterModel.name}`;
      this.costCenterId = costCenterModel.costCenterId;
      this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;
      this.formRequestNote.controls["ivaTypeId"].patchValue(costCenterModel.ivaTypeId);
      this.formRequestNote.controls["administrationRate"].patchValue(costCenterModel.administrationRate);
      this.formRequestNote.controls["incidentalRate"].patchValue(costCenterModel.incidentalRate);
      this.formRequestNote.controls["utilityRate"].patchValue(costCenterModel.utilityRate);
    } else {
      this.codeNameCostCenter = '';
      this.costCenterId = null;
      this.formRequestNote.controls["ivaTypeId"].patchValue(IvaTypeEnums.pleno);
      this.formRequestNote.controls["administrationRate"].patchValue(0);
      this.formRequestNote.controls["incidentalRate"].patchValue(0);
      this.formRequestNote.controls["utilityRate"].patchValue(0);;
    }
  }

  async getConcept(conceptId: number | null) {
    const conceptIdOld = this.noteContract.conceptId;
    const quantityDetails = this.quantityDetails !== 0;
    if (conceptId) {
      const concept = this.listConcepts.find(x => x.value === conceptId);
      if (concept && conceptId !== conceptIdOld && quantityDetails) {
        const accepted = await this.confirmDialogService.confirm(
          `La nota tiene detalles asociados. ¿Realmente desea modificar el concepto?`
        );
        if (accepted) {
          this.changeValues();
        } else {
          this.formRequestNote.controls['conceptId'].patchValue(conceptIdOld);
        }
      }
    }
  }

  async getBussinessDocumentsTypeInvoice(bussinessDocumentsTypeInvoiceId: number | null, reload: boolean) {
    await this.getListBussinessDocumentsTypeInvoice();
    if (bussinessDocumentsTypeInvoiceId != null && bussinessDocumentsTypeInvoiceId != 0) {
      const bussinessDocumentsTypeInvoice = this.listBussinessDocumentsTypesInvoice.find(x => x.value == bussinessDocumentsTypeInvoiceId);
      if (bussinessDocumentsTypeInvoice) {
        this.bussinessDocumentsTypeInvoiceForm.patchValue(bussinessDocumentsTypeInvoiceId);
        this.bussinessDocumentsTypeInvoiceId = bussinessDocumentsTypeInvoiceId;
      } else {
        this.bussinessDocumentsTypeInvoiceId = 0;
        return
      }
    }
    this.changeInvoice(this.formRequestNote.get("invoiceConsecutive")?.value);
    if (reload) {
      this.changeValues();
    }
  }

  async getBussinessDocumentsType(bussinessDocumentsTypeId: number | null, reload: boolean) {
    await this.getListBussinessDocumentsType();
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(x => x.value == bussinessDocumentsTypeId);
      if (bussinessDocumentsType) {
        this.formRequestNote.controls["bussinessDocumentsTypeId"].patchValue(bussinessDocumentsTypeId);
        this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      } else {
        this.formRequestNote.controls["bussinessDocumentsTypeId"].patchValue(0);
        return;
      }
    } else {
      this.formRequestNote.controls["bussinessDocumentsTypeId"].patchValue(0);
    }
    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formRequestNote.get("branchId")?.value;
    const enterpriseId = this.formRequestNote.get("enterpriseId")?.value;
    const noteTypeId = this.formRequestNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formRequestNote.get("bussinessDocumentsTypeId")?.value;
    let requestConsecutive = this.formRequestNote.get("requestConsecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (noteTypeId == null || noteTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de nota.', 'Atención');
      return;
    }
    else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (requestConsecutive == 0) {
      requestConsecutive = null;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.noteContract = await firstValueFrom(this.requestNoteService.getFirstRequestNoteByKeysAsync(
            branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId
          ));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/request-note/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la primera nota:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.noteContract = await firstValueFrom(this.requestNoteService.getPreviusRequestNoteByKeysAsync(
            branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId, requestConsecutive
          ));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/request-note/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la nota anterior:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.noteContract = await firstValueFrom(this.requestNoteService.getNextRequestNoteByKeysAsync(
            branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId, requestConsecutive
          ));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/request-note/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la nota siguiente:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.noteContract = await firstValueFrom(this.requestNoteService.getLastRequestNoteByKeysAsync(
            branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId
          ));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/request-note/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la ultima nota:', error);
        }
        break;
      }
    }
  }

  async getEnterprise(enterpriseId: number | null, reload: boolean) {
    if (enterpriseId != null && enterpriseId != 0) {
      const enterprise = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      if (enterprise) {
        this.enterpriseId = enterpriseId;
        this.formRequestNote.controls["enterpriseId"].patchValue(this.enterpriseId);
        this.swElectronicInvoice = enterprise.swElectronicInvoice;
        this.copyListOperationsTypeDian = [...this.listOperationsTypeDian];
        if (this.swElectronicInvoice) {
          this.copyListOperationsTypeDian.splice(2, 1);
        } else {
          this.copyListOperationsTypeDian.splice(0, 2);
        }
      } else {
        this.enterpriseId = 0;
        this.formRequestNote.controls["enterpriseId"].patchValue(this.enterpriseId);
        return;
      }
    } else {
      this.enterpriseId = 0;
      this.formRequestNote.controls["enterpriseId"].patchValue(this.enterpriseId);
    }
    if (reload) {
      this.changeEnterprise();
      this.getFirstBussinessDocumentsType();
      this.getFirstBussinessDocumentsTypeInvoice();
    }
  }

  async getFilesToRequestNote() {
    try {
      this.listFiles = await firstValueFrom(this.requestNoteService.getFilesToRequestNote(this.noteId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable
        .pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal principal del usuario autenticado:', error);
    }
  }

  async getFirstBranchEnterprise() {
    try {
      await this.getBranch(this.mainBranchByUser.branchId, false);
      await this.getFirstEnterpriseByBranch(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado:', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null): Promise<void> {
    if (branchId != null && branchId !== 0) {
      try {
        const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
        if (response) {
          this.enterpriseId = response.enterpriseId;
          this.configureNoteType();
          await this.getEnterprise(this.enterpriseId, false);
          await this.getFirstBussinessDocumentsType();
          await this.getFirstBussinessDocumentsTypeInvoice();
        } else {
          this.enterpriseId = 0;
        }
      } catch (error) {
        console.error('Error al buscar la primera empresa de la sucursal:', error);
      }
    }
  }

  async getFirstBussinessDocumentsType() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(this.bussinessDocumentsClassId,
        this.enterpriseId));
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      this.listBussinessDocumentsTypes = [];
      console.error('Error al obtener el primer tipo de documento comercial:', error);
    }
  }

  async getFirstBussinessDocumentsTypeInvoice() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(this.bussinessDocumentsTypeClass,
        this.enterpriseId));
      this.getBussinessDocumentsTypeInvoice(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      this.listBussinessDocumentsTypesInvoice = [];
      console.error('Error al obtener el tipo de documento comercial de la factura:', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      if (this.formatModel.formatId == 0)
        this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.requestNote));
    } catch (error) {
      console.error('Error al obtener el formato:', error);
    }
  }

  async getListBussinessDocumentsType() {
    try {
      this.listBussinessDocumentsTypes = await firstValueFrom(
        this.noteService.getAllBussinessDocumentsTypesForSelectAsync(
          this.bussinessDocumentsClassId, this.branchId, this.enterpriseId
        ));
    } catch (error) {
      this.listBussinessDocumentsTypes = [];
      console.error('Error al obtener el tipo documento por tipo de nota:', error);
    }
  }

  async getListBussinessDocumentsTypeInvoice() {
    try {
      this.listBussinessDocumentsTypesInvoice = await firstValueFrom(
        this.noteService.getAllBussinessDocumentsTypesInvoiceForSelectAsync(false, this.branchId, this.enterpriseId)
      );
    } catch (error) {
      this.listBussinessDocumentsTypesInvoice = [];
      console.error('Error al obtener el tipo documento por tipo de factura:', error);
    }
  }

  async getInvoiceByCode() {
    try {
      const response = await firstValueFrom(this.invoiceService.getInvoiceByParamsAsync(
        this.branchId, this.enterpriseId, this.bussinessDocumentsTypeInvoiceId, this.invoiceConsecutive
      ));
      this.noteContract.invoiceId = response.invoiceId;
      this.dateInvoice = formatDate(response.dateInvoice, 'dd/MM/yyyy', 'en-US');
      this.totalValueInvoice = response.totalValue;
      this.residueValueInvoice = response.residueValue;
      this.getCostCenter(response.costCenter);
      this.getClient(response.clientId);
    } catch (error) {
      this.getCostCenter(new CostCenterModel());
      this.getClient(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      this.noteContract.invoiceId = -1;
      console.error('Error al buscar la factura por codigo:', error);
    }
  }

  async getInvoiceById(invoiceId: number | null) {
    if (invoiceId != null && invoiceId != 0) {
      try {
        const response = await firstValueFrom(this.invoiceService.getInvoiceById(invoiceId));
        this.noteContract.invoiceId = response.invoiceId;
        this.invoiceConsecutive = response.consecutive;
        this.formRequestNote.controls["invoiceConsecutive"].patchValue(this.invoiceConsecutive);
        this.dateInvoice = formatDate(response.dateInvoice, 'dd/MM/yyyy', 'en-US');
        this.totalValueInvoice = response.totalValue;
        this.residueValueInvoice = response.residueValue;
        this.getCostCenter(response.costCenter);
        this.getClient(response.clientId);
      } catch (error) {
        this.invoiceConsecutive = 0;
        this.getCostCenter(new CostCenterModel());
        this.getClient(0);
        this.dateInvoice = '';
        this.totalValueInvoice = 0;
        this.residueValueInvoice = 0;
        console.error('Error al buscar la factura por Id:', error);
      }
    }
  }

  async getNoteById() {
    try {
      this.noteContract = await firstValueFrom(this.noteService.getNoteById(this.noteId));
      if (this.branchId != this.noteContract.branchId) {
        this.branchId = this.noteContract.branchId;
        try {
          this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
        } catch (error) {
          console.error('Error al buscar las empresas de la sucursal.', error);
        }
      }
    } catch (error) {
      console.error('Error al buscar la nota:', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    url = url.substring(0, url.indexOf("/"));
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil:', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.requestNoteService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión:', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.userAuthenticated = await firstValueFrom(
        this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      );
    } catch (error) {
      console.error('Error al obtener el usuario autenticado:', error);
    }
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.RequestNote));
    } catch (error) {
      console.error('Error al obtener permisos para solicitud de nota:', error);
    }
  }

  async getPrintNote(reload: boolean) {
    try {
      this.requestNotePrintModel = await firstValueFrom(
        this.requestNoteService.getRequestNoteByKeysByPrintAsync(this.noteContract.branchId, this.noteContract.requestConsecutive, reload, this.noteId)
      );
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  getUpdateNote(note: NoteModel) {
    this.noteContract = note;
    this.validateForm(this.noteContract);
  }

  async handleInitialState() {
    if (this.noteId !== null && this.noteId !== 0) {
      this.editNote();
      this.formRequestNote.get("isLevelArticle")?.disable();
      this.formRequestNote.get("invoiceConsecutive")?.disable();
    } else {
      await this.getFirstBranchEnterprise();
      this.createNewRequestNote();
    }
  }

  initNoteTypeOptions(): void {
    this.listNoteTypeFiltered = this.listNoteTypes.filter(x => x.value == NoteTypeEnums.creditNote || x.value == NoteTypeEnums.debitNote);
  }

  async loadExistingNoteData(): Promise<void> {
    this.noteId = this.noteContract.noteId;
    this.formRequestNote.enable();
    const promises = [];

    promises.push(this.getBranch(this.noteContract.branchId, false));
    promises.push(this.getEnterprise(this.noteContract.enterpriseId, false));
    promises.push(this.getBussinessDocumentsType(this.noteContract.bussinessDocumentsTypeId, false));
    promises.push(this.getConcept(this.noteContract.conceptId));

    this.invoiceSwSelfRetainer = this.noteContract.invoice?.enterpriseSwSelfRetainer ?? false;
    this.invoiceSwIcaSelfRetainer = this.noteContract.invoice?.enterpriseSwIcaSelfRetainer ?? false;
    const invoicePromise = this.getInvoiceById(this.noteContract.invoiceId);
    promises.push(invoicePromise);
    promises.push(invoicePromise.then(() => {
      return this.getBussinessDocumentsTypeInvoice(this.noteContract.invoice!.bussinessDocumentsTypeId, false);
    }));
    await Promise.all(promises);
  }

  onQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
    if (this.quantityDetails > 0 || this.noteContract.requestNoteStateId != NoteStateEnums.open) {
      setTimeout(() => {
        this.formRequestNote.get("isLevelArticle")?.disable();
        this.formRequestNote.get("invoiceConsecutive")?.disable();
        this.bussinessDocumentsTypeInvoiceForm?.disable();
      }, 100);
    } else {
      setTimeout(() => {
        this.formRequestNote.get("invoiceConsecutive")?.enable();
        this.bussinessDocumentsTypeInvoiceForm?.enable();
      }, 100);
    }
  }

  async openAttachFile() {
    if (this.noteContract.noteId != 0 && this.noteContract.noteId != null) {
      await this.getFilesToRequestNote();
      this.attachFileRequestNoteComponent && this.attachFileRequestNoteComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una solicitud de nota.', 'Atención');
    }
  }

  async printPage() {
    if (!this.noteContract || this.noteContract.noteId === 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la nota.`, 'Atención');
      return;
    }

    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir solicitudes de notas. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    //Muestro formato:
    this.printNoteFormat = true;
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintNote(true);
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
    await this.getNoteById();
    this.validateForm(this.noteContract);
    //Oculto formato:
    this.printNoteFormat = false;
  }

  resetNoteState() {
    this.noteId = 0;
    this.clientId = 0;
    this.codeCurrency = '';
    this.codeNameClient = '';
    this.codeNameCostCenter = '';
    this.dateInvoice = 'dd/mm/aaaa';
    this.invoiceConsecutive = 0;
    this.invoiceSwIcaSelfRetainer = false;
    this.invoiceSwSelfRetainer = false;
    this.quantityDetails = 0;
    this.residueValueInvoice = 0;
    this.stateClientId = ClientStateEnums.activo;
    this.stateCostCenterId = ClientStateEnums.activo;
    this.totalValueInvoice = 0;
  }

  async send() {
    Object.keys(this.formRequestNote.controls).forEach(key => {
      const control = this.formRequestNote.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRequestNote.valid) {
      this.formRequestNote.controls["operationTypeDian"].enable();
      const modelNote = this.formRequestNote.getRawValue() as NoteModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelNote.clientId == 0) modelNote.clientId = null;
      if (modelNote.providerId == 0) modelNote.providerId = null;
      if (modelNote.invoiceId == 0) modelNote.invoiceId = null;
      if (modelNote.documentSupportId == 0) modelNote.documentSupportId = null;
      if (modelNote.costCenterId == 0) modelNote.costCenterId = null;
      if (modelNote.observation == '') modelNote.observation = null;
      if (modelNote.observationPrint == '') modelNote.observationPrint = null;
      if (modelNote.cude == '') modelNote.cude = null;
      if (modelNote.responseAcuse == '') modelNote.responseAcuse = null;
      if (modelNote.responseEmailAcuse == '') modelNote.responseEmailAcuse = null;
      if (modelNote.statusDianCode == '') modelNote.statusDianCode = null;
      if (modelNote.statusDianDescription == '') modelNote.statusDianDescription = null;
      if (modelNote.technologicalProviderMessageCode == '') modelNote.technologicalProviderMessageCode = null;
      if (modelNote.technologicalProviderMessageDescription == '') modelNote.technologicalProviderMessageDescription = null;
      if (modelNote.xmlName == '') modelNote.xmlName = null;
      if (modelNote.clientStatusCode == '') modelNote.clientStatusCode = null;

      if (this.noteContract.invoiceId === -1) {
        this.toastHandlerService.showToast('warning', `Debe seleccionar una factura válida.`, 'Atención');
        return;
      }
      modelNote.invoiceId = this.noteContract.invoiceId;
      modelNote.clientId = this.clientId;
      modelNote.costCenterId = this.costCenterId == 0 ? null : this.costCenterId;

      if (this.noteId == 0) {
        try {
          const response = await firstValueFrom(this.requestNoteService.createRequestNote(modelNote));
          this.toastHandlerService.showToast('success', `La solicitud de nota fue creada exitosamente.`);
          this.noteContract = response;
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/request-note/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al crear la solicitud de nota:', error);
        }
      } else {
        this.noteContract.isLevelArticle = modelNote.isLevelArticle;
        this.noteContract.dateNote = modelNote.dateNote;
        this.noteContract.conceptId = modelNote.conceptId;
        this.noteContract.operationTypeDian = modelNote.operationTypeDian;
        this.noteContract.invoiceId = modelNote.invoiceId;
        this.noteContract.documentSupportId = modelNote.documentSupportId;
        this.noteContract.clientId = modelNote.clientId;
        this.noteContract.costCenterId = modelNote.costCenterId;
        this.noteContract.observationPrint = modelNote.observationPrint;
        this.noteContract.observation = modelNote.observation;
        try {
          const response = await firstValueFrom(this.requestNoteService.updateRequestNote(this.noteContract));
          this.toastHandlerService.showToast('success', `La solicitud de nota fue modificada exitosamente.`);
          this.noteContract = response;
          this.validateForm(this.noteContract);
        } catch (error) {
          console.error('Error al actualizar la solicitud de nota:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo "Sucursal" es obligatorio.',
      enterpriseId: 'El campo "Empresa" es obligatorio.',
      noteTypeId: 'El campo "Tipo de nota" es obligatorio.',
      isLevelArticle: 'El campo "Nivel" es obligatorio.',
      dateNote: 'El campo "Fecha" es obligatorio.',
      conceptId: 'El campo "Concepto" es obligatorio.',
      operationTypeDian: 'El campo "Tipo de operación" es obligatorio.',
      invoiceConsecutive: `El campo "factura" es obligatorio.`,
      observation: 'El campo "Observación" permite un máximo de 250 caracteres.',
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formRequestNote.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  async updateConceptListByNoteType() {
    try {
      this.listConcepts = await firstValueFrom(this.noteService.getAllConceptForSelectAsync(this.typeConcept));
    } catch (error) {
      console.error("Error al obtener la lista conceptos:", error);
    }
  }

  async updateFormState() {
    const stateConfig: any = {
      [NoteStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        iconStateProcess: 'pi pi-check',
        titleStateProcess: 'Autorizar'
      },
      [NoteStateEnums.closed]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        iconStateProcess: 'pi pi-check',
        titleStateProcess: 'Autorizar'
      },
      [NoteStateEnums.printed]: {
        severity: 'info',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impresa',
        iconStateProcess: 'pi pi-verified',
        titleStateProcess: 'Verificada'
      },
      //Revisar estados nuevos para configurar correctamente:
      [NoteStateEnums.authorized]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Autorizada',
        iconStateProcess: 'pi pi-check-circle',
        titleStateProcess: 'Revisar'
      },
      [NoteStateEnums.revised]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Revisada',
        iconStateProcess: 'pi pi-verified',
        titleStateProcess: 'Aprobar'
      },
      [NoteStateEnums.approved]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Aprobada',
        iconStateProcess: 'pi pi-verified',
        titleStateProcess: 'Aprobada'
      },
      [NoteStateEnums.annulled]: {
        severity: 'warn',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulada',
        iconStateProcess: 'pi pi-check',
        titleStateProcess: 'Anulada'
      },
      [NoteStateEnums.generated]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Generada',
        iconStateProcess: 'pi pi-verified',
        titleStateProcess: 'Generada'
      },
    };

    const currentState = this.noteContract.requestNoteStateId;
    const config = stateConfig[currentState];

    if (config) {
      this.iconStateRequestNote = config.icon;
      this.titleStateRequestNote = config.title;
      this.requestNoteStateString = config.text;
      this.severityState = config.severity;
      //Estados de la solicitud de nota:
      this.titleStateProcess = config.titleStateProcess;
      this.iconStateProcess = config.iconStateProcess;
    }

    this.disabledButtons = false;
    if (this.noteContract.requestNoteStateId == NoteStateEnums.open) {
      this.disabledActions = false;
      this.headerChanged = false;

      if (this.noteId != 0) {
        setTimeout(() => this.formRequestNote.controls["requestConsecutive"].enable(), 100);
      } else {
        setTimeout(() => this.formRequestNote.controls["requestConsecutive"].disable(), 100);
      }
    } else {
      this.disabledActions = true;
      setTimeout(() => this.formRequestNote.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(
        this.formRequestNote, ['branchId', 'enterpriseId', 'noteTypeId', 'bussinessDocumentsTypeId', 'requestConsecutive'], true
      ), 100);
      this.bussinessDocumentsTypeInvoiceForm?.disable();
    }
    if (this.noteContract.requestNoteStateId == NoteStateEnums.annulled) {
      this.disabledButtons = true;
    }
    // setTimeout(() => this.formRequestNoteTotals.disable(), 0);
    if (!this.permissionUpdatable) setTimeout(() => this.formRequestNote.disable(), 100);
    setTimeout(() => this.formControlStateService.setControlState(this.formRequestNote, ['elaborate', 'authorize', 'revise', 'approve'], false), 100);
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.noteContract.requestConsecutive,
      disabled: this.noteContract.requestNoteStateId != NoteStateEnums.open
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.requestNoteService.attachFilesToRequestNote(this.noteId, formData));
      await this.getFilesToRequestNote();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async validateForm(note: NoteModel) {
    this.formRequestNote = this.formBuilder.group({
      branchId: [note.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [note.enterpriseId, [Validators.required, Validators.min(1)]],
      noteTypeId: [note.noteTypeId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeId: [note.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      requestConsecutive: [note.requestConsecutive, [Validators.required]],
      isLevelArticle: [note.isLevelArticle, [Validators.required]],
      dateNote: [note.dateNote ? this.dateConverterService.convertUtcToLocalDate(note.dateNote) : null, [Validators.required]],
      conceptId: [note.conceptId, [Validators.required, Validators.min(1)]],
      operationTypeDian: [note.operationTypeDian, [Validators.required]],
      invoiceId: [note.invoiceId],
      invoiceConsecutive: [note.invoice?.consecutive],
      clientId: [note.clientId],
      costCenterId: [note.costCenterId],
      elaborate: [{ value: note.elaborate, disabled: true }],
      authorize: [{ value: note.authorize, disabled: true }],
      revise: [{ value: note.revise, disabled: true }],
      approve: [{ value: note.approve, disabled: true }],
      observationPrint: [note.observationPrint, [Validators.maxLength(500)]],
      observation: [note.observation, [Validators.maxLength(500)]],
      ivaTypeId: [note.ivaTypeId, [Validators.required]],
      administrationRate: [note.administrationRate, [Validators.min(0), Validators.max(100)]],
      incidentalRate: [note.incidentalRate, [Validators.min(0), Validators.max(100)]],
      utilityRate: [note.utilityRate, [Validators.min(0), Validators.max(100)]],
      reteIvaRate: [note.reteIvaRate, [Validators.min(0), Validators.max(100)]],
    });
    this.formRequestNoteTotals = this.formBuilder.group({
      subtotalValue: [{ value: note.subtotalValue, disabled: true }],
      ivaValue: [{ value: note.ivaValue, disabled: true }],
      totalValue: [{ value: note.totalValue, disabled: true }],
      reteIvaValue: [{ value: note.reteIvaValue, disabled: true }],
      reteFuenteValue: [{ value: note.reteFuenteValue, disabled: true }],
      reteIcaValue: [{ value: note.reteIcaValue, disabled: true }],
      valueToPay: [{ value: note.valueToPay, disabled: true }],
    });
    if (this.noteContract.noteId != 0) {
      await this.loadExistingNoteData();
    }
    this.updateFormState();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }

}